import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import Overlay from './Overlay';

const styles = {
  progress: {
    position: "relative",
    top: "50%",
    left: "50%",
    marginLeft: -25,
    marginRight: -25
  }
}

const LoadingOverlay = ({ classes }) => (
  <Overlay>
    <CircularProgress classes={{root: classes.progress}} size={30} color="secondary"/>
  </Overlay>
);

export default withStyles(styles)(LoadingOverlay);
